import { Company } from "../models/Company";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const getCompanies = async (): Promise<Company[]> => {
  const response = await fetch(`${API_BASE_URL}/Company/GetAll`);
  const data = await response.json();
  return data;
};

const addCompany = async (company: Company): Promise<any> => {
  const response = await fetch(`${API_BASE_URL}/Company/Add`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(company),
  });
  if (!response.ok) throw new Error("Error al agregar compañía");
  return response;
};

const updateCompany = async (company: Company): Promise<any> => {
  const response = await fetch(`${API_BASE_URL}/Company/Update/${company.id}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(company),
  });
  if (!response.ok) throw new Error("Error al actualizar compañía");
  return response;
};

const deleteCompany = async (id: number): Promise<any> => {
  const response = await fetch(`${API_BASE_URL}/Company/Delete/${id}`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
  });
  return response
};

const CompanyService = {
  getCompanies,
  addCompany,
  updateCompany,
  deleteCompany,
};

export default CompanyService;